import Panel from '../../../../components/Panel/Panel';

import type { ISurveyAnswerItemPanel } from '../interfaces/ISurveyAnswerItemPanel';

import styles from '../scss/SurveyAnswer.module.scss';

function SurveyAnswerItemPanel({
  children,
  title,
  description = undefined,
}: ISurveyAnswerItemPanel) {
  return (
    <Panel className={styles.panel}>
      <div className={styles.panelHeader}>
        <div className={styles.panelTitleSection}>
          <p className={styles.title}>{title}</p>
          {description ? <p className={styles.description}>{description}</p> : null}
        </div>
      </div>
      {children}
    </Panel>
  );
}

export default SurveyAnswerItemPanel;
